import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';

import { Heading } from '@beef/legacy-ui-kit';
import { Button } from '@beef/ui-kit';
import { IncludeContent } from 'bricks';
import classNames from 'classnames/bind';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  closeOutOfStockPopup,
  submitOutOfStockForm,
  toggleAgreementCheckbox,
} from 'store/Comparison/outofstock/actions';
import {
  getOutOfStockAgreementDataText,
  getOutOfStockAgreementState,
  getOutOfStockErrorFetchedText,
  getOutOfStockPopupDescription,
  getOutOfStockPopupHeader,
  getOutOfStockPopupState,
  getOutOfStockSuccessText,
  getOutOfStockView,
} from 'store/Comparison/outofstock/selectors';

import OutOfStockForm from '../OutOfStockForm';
import { PopupStateless } from '../Popup';
import { OUT_OF_STOCK_FORM_NAME, OUT_OF_STOCK_FORM_VIEW, OUT_OF_STOCK_SUCCESS_VIEW } from './constants';
import styles from './styles.pcss';

const cx = classNames.bind({ ...styles });

const OutOfStockHeading: React.FC<PropsWithChildren> = ({ children }) => (
  <Heading className={cx('text')}>{children}</Heading>
);

type Props = {
  errorFetchedText: string;
  id: number;
  isMobile: boolean;
  isOpen: boolean;
  onClose: () => void;
  outOfStockSuccessText: string;
  outOfStockView: string;
  submitForm: () => void;
};

export const OutOfStockPopup: React.FC<Props> = ({
  errorFetchedText,
  id,
  isMobile,
  isOpen,
  onClose,
  outOfStockSuccessText,
  outOfStockView,
  ...otherProps
}) => {
  return (
    <PopupStateless
      onClose={onClose}
      opened={isOpen}
    >
      {outOfStockView === OUT_OF_STOCK_FORM_VIEW ?
        <OutOfStockForm {...otherProps} />
        : <>
          <IncludeContent
            className={cx('text', isMobile && 'mobile')}
            htmlContent={outOfStockView === OUT_OF_STOCK_SUCCESS_VIEW ? outOfStockSuccessText : errorFetchedText}
            replaceTags={{ OutOfStockHeading }}
          />
          <div className={cx('button')}>
            <Button
              onClick={onClose}
              size="l"
              type="button"
              variant="main"
            >
              OK
            </Button>
          </div>
        </>
      }
    </PopupStateless>
  );
};

const mapStateToProps = state => {
  const formName = OUT_OF_STOCK_FORM_NAME;
  return {
    agreementText: getOutOfStockAgreementDataText(state),
    errorFetchedText: getOutOfStockErrorFetchedText(state),
    isAgreementUnchecked: getOutOfStockAgreementState(state, formName),
    isMobile: isScreenBelow800(state),
    isOpen: getOutOfStockPopupState(state),
    outOfStockDescription: getOutOfStockPopupDescription(state),
    outOfStockFormName: formName,
    outOfStockHeader: getOutOfStockPopupHeader(state),
    outOfStockSuccessText: getOutOfStockSuccessText(state),
    outOfStockView: getOutOfStockView(state),
  };
};

const mapDispatchToProps = {
  onClose: closeOutOfStockPopup,
  onToogleAgreement: toggleAgreementCheckbox,
  submitForm: submitOutOfStockForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(OutOfStockPopup);
